import React from 'react';
import './style.css';

const LineButton = () => {
  return (
    <div className="line-button-container">
      <a href="https://lin.ee/qDCUHjt">
        <img 
          src="https://scdn.line-apps.com/n/line_add_friends/btn/th.png" 
          alt="เพิ่มเพื่อน" 
          height="36" 
          border="0"
        />
      </a>
    </div>
  );
};

export default LineButton;